import { Link, Typography } from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import * as React from "react";

export const LSResultItemAuthor = ({
  shortAuthor,
}: {
  shortAuthor: string;
}) => {
  const { translate } = useLanguage();

  if (!shortAuthor) {
    return null;
  }

  return (
    <Typography component="h4">
      {translate("by")}{" "}
      <Link href={`#section=search&term=au:${shortAuthor}`}>{shortAuthor}</Link>
    </Typography>
  );
};
